export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(numValue)) return '-';
  return numValue.toLocaleString();
};

/** ISO/Date → KST 표시 (예: 2026-09-09 00:10:25) */
export const formatKstDateTime = (value, { seconds = true } = {}) => {
  if (value == null || value === '') return '-';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(d);
  const get = (type) => parts.find((p) => p.type === type)?.value || '';
  const time = seconds ? `${get('hour')}:${get('minute')}:${get('second')}` : `${get('hour')}:${get('minute')}`;
  return `${get('year')}-${get('month')}-${get('day')} ${time}`;
};

export const formatKstDate = (value) => {
  const s = formatKstDateTime(value);
  return s === '-' ? s : s.slice(0, 10);
};

/** "3분 전", "2시간 전", "5일 전" */
export const formatRelative = (value) => {
  if (!value) return '-';
  const diff = Date.now() - new Date(value).getTime();
  if (Number.isNaN(diff)) return '-';
  const abs = Math.abs(diff);
  const suffix = diff >= 0 ? '전' : '후';
  if (abs < 60000) return diff >= 0 ? '방금' : '곧';
  if (abs < 3600000) return `${Math.floor(abs / 60000)}분 ${suffix}`;
  if (abs < 86400000) return `${Math.floor(abs / 3600000)}시간 ${suffix}`;
  return `${Math.floor(abs / 86400000)}일 ${suffix}`;
};

/** 남은 일수 (만료일까지) */
export const daysUntil = (value) => {
  if (!value) return null;
  return Math.ceil((new Date(value).getTime() - Date.now()) / 86400000);
};

/** User-Agent 요약 */
export const summarizeUserAgent = (ua) => {
  if (!ua) return '-';
  if (/^axios\//i.test(ua)) return '에이전트(axios)';
  const browser =
    (/Edg\//.test(ua) && 'Edge') ||
    (/Chrome\//.test(ua) && 'Chrome') ||
    (/Firefox\//.test(ua) && 'Firefox') ||
    (/Safari\//.test(ua) && 'Safari') ||
    null;
  const os =
    (/Windows/.test(ua) && 'Windows') ||
    (/Android/.test(ua) && 'Android') ||
    (/iPhone|iPad/.test(ua) && 'iOS') ||
    (/Mac OS/.test(ua) && 'macOS') ||
    (/Linux/.test(ua) && 'Linux') ||
    null;
  return [browser, os].filter(Boolean).join(' / ') || ua.slice(0, 40);
};
